import script from "./Grid3x2SVG.vue?vue&type=script&setup=true&lang=js"
export * from "./Grid3x2SVG.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__